import { render, staticRenderFns } from "./PackagesList.vue?vue&type=template&id=09964aba&scoped=true"
import script from "./PackagesList.vue?vue&type=script&lang=js"
export * from "./PackagesList.vue?vue&type=script&lang=js"
import style0 from "./PackagesList.vue?vue&type=style&index=0&id=09964aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09964aba",
  null
  
)

export default component.exports